import { Inject, Injectable, Optional } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { SESSION_STORAGE_TOKEN } from './tokens';



@Injectable()
export class SessionStorageService {
    private storage: Map<string, any> = new Map();
    private namespace: string;

    constructor(@Optional() @Inject(SESSION_STORAGE_TOKEN) namespace?: string) {
        this.namespace = namespace || 'default';
        this.loadFromSessionStorage();
    }

    private getStorageKey(key: string): string {
        return `${this.namespace}::${key}`;
    }

    private loadFromSessionStorage(): void {
        Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith(this.namespace + '::')) {
                try {
                    this.storage.set(key, JSON.parse(sessionStorage.getItem(key) || null));
                } catch (e) {
                    console.error('Error parsing sessionStorage item', e);
                }
            }
        });
    }

    setItem(key: string, value: any): void {
        try {
            const storageKey = this.getStorageKey(key);
            sessionStorage.setItem(storageKey, JSON.stringify(value));
            this.storage.set(storageKey, value);
        } catch (e) {
            console.error('Error saving to sessionStorage', e);
        }
    }

    getItem<T>(key: string, cls: new (...args: any[]) => T): T | null {
        const storageKey = this.getStorageKey(key);
        if (this.storage.has(storageKey)) {
            const storedValue = this.storage.get(storageKey);
            return plainToClass(cls, storedValue);
        }
        return null;
    }

    getItemArray<T>(key: string, cls: new (...args: any[]) => T): T[] | null {
        const storageKey = this.getStorageKey(key);
        if (this.storage.has(storageKey)) {
            const storedValue = this.storage.get(storageKey) as any[];
            return plainToClass(cls, storedValue);
        }
        return null;
    }

    removeItem(key: string): void {
        const storageKey = this.getStorageKey(key);
        sessionStorage.removeItem(storageKey);
        this.storage.delete(storageKey);
    }

    clear(): void {
        Array.from(this.storage.keys()).forEach(key => {
            if (key.startsWith(this.namespace + '::')) {
                sessionStorage.removeItem(key);
                this.storage.delete(key);
            }
        });
    }


}
